import React from 'react';
import { connect } from 'react-redux';
import '@/companys/scb/assets/styles/components/order/order-audit.scss';
import { dataType } from '@/constants/data-type';
import { Comparator } from '../../helpers/functions';
import DataTable from '../DataTable/DataTable';

class OrderAudit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          headerName: props.language.common_time,
          colId: 'common_time',
          field: 'actionTime',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.LONG_DATE,
          minWidth: 135
        },
        /* {
          headerName: props.language.common_symbol,
          colId: 'common_symbol',
          field: 'stockCode',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SYMBOL,
          cellRendererParams: {
            market: 'marketID',
            instrument: 'stockCode',
          },
          minWidth: 80
        },
        {
          headerName: props.language.common_buy_sell,
          colId: 'common_buy_sell',
          field: 'bs',
          headerClass: 'table-header text-center',
          cellClass: 'table-cell text-center',
          dataType: dataType.ORDER_CELL_RENDER,
          minWidth: 80
        }, */
        {
          headerName: props.language.common_price,
          colId: 'common_price',
          field: 'actionPrice',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 60
        },
        {
          headerName: props.language.common_qty,
          colId: 'common_qty',
          field: 'actionQty',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          minWidth: 50
        },
        {
          headerName: props.language.common_status,
          colId: 'common_status',
          field: 'status',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.ORDER_CELL_RENDER,
          minWidth: 100
        },
        // {
        //   headerName: props.language.common_actions,
        //   colId: 'common_actions',
        //   field: 'actionDesc',
        //   headerClass: 'table-header',
        //   cellClass: 'table-cell',
        //   dataType: dataType.TEXT,
        //   minWidth: 130
        // },
        {
          headerName: props.language.common_remark,
          colId: 'common_remark',
          field: 'remark',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
          wrapText: true,
          minWidth: 300
        }
      ]
    };
  }

  render() {
    const { language, auditList } = this.props;
    const { columnDefs } = this.state;

    return (
      <React.Fragment>
        <div className='order-audit-container'>
          <header>{language.order_audit}</header>
          <div className='table-container' style={{ height: (auditList.length + 0.9) * 60}}>
            <DataTable
              columnDefs={columnDefs}
              data={auditList}
              innerRef={e => this.auditGridRef = e}
              showPagination={false}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => ({
    language: state.app.language
  }),
  (dispatch) => ({

  })
)(OrderAudit);
